// frontend/klaes-app/src/components/FilmFavs/utils/helpers.js

// Farben für Chip-Kategorien (zentrale Definition)
export const categoryColors = {
  genre: '#3b82f6',
  mood: '#f59e0b',
  era: '#10b981',
  country: '#ef4444',
  theme: '#8b5cf6',
  misc: '#ec489a',
  actor_regisseur: '#06b6d4',
  artist_composer: '#06b6d4',
  epoch: '#10b981',
  form: '#8b5cf6',
  format: '#ec489a'
};

// Kategorien für TagPicker (zentrale Definition)
export const tagCategories = [
  { id: 'all', label: 'Alle', icon: '🎲' },
  { id: 'genre', label: 'Genre', icon: '🎬' },
  { id: 'mood', label: 'Mood', icon: '😊' },
  { id: 'era', label: 'Era', icon: '📅' },
  { id: 'country', label: 'Country', icon: '🌍' },
  { id: 'theme', label: 'Theme', icon: '🎯' },
  { id: 'misc', label: 'Misc', icon: '📌' },
  { id: 'actor_regisseur', label: 'Actor/Regisseur', icon: '🎭' }
];

// Batterie-Level berechnen
export const getBatteryLevel = (rating) => {
  if (rating <= 16.5) return { level: 1, color: 'red' };
  if (rating <= 33) return { level: 2, color: 'red' };
  if (rating <= 66) return { level: 3, color: 'orange' };
  if (rating <= 83.5) return { level: 4, color: 'green' };
  return { level: 5, color: 'green' };
};

export const filterEntries = (entries, filter, includeTags = true) => {
  let filtered = [...entries];

  if (filter.type !== 'both') {
    filtered = filtered.filter(entry => entry.type === filter.type);
  }

  if (filter.term?.trim()) {
    const term = filter.term.toLowerCase();
    filtered = filtered.filter(entry =>
      entry.name.toLowerCase().includes(term) ||
      entry.description.toLowerCase().includes(term) ||
      entry.artist?.toLowerCase().includes(term) ||
      entry.author?.toLowerCase().includes(term)
    );
  }

  if (includeTags && filter.tags?.length) {
    if (filter.matchMode === 'and') {
      filtered = filtered.filter(entry =>
        filter.tags.every(filterTag =>
          entry.tags.some(tag => tag.name === filterTag.name && tag.category === filterTag.category)
        )
      );
    } else {
      filtered = filtered.filter(entry =>
        filter.tags.some(filterTag =>
          entry.tags.some(tag => tag.name === filterTag.name && tag.category === filterTag.category)
        )
      );
    }
  }

  return filtered;
};